///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = modules.ribit || {};
modules.ribit.reporting = modules.ribit.reporting || {};
modules.ribit.reporting.edit = modules.ribit.reporting.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit.reporting.edit = {
    /**
     *
     */
    init: function () {
        modules.ribit.reporting.common.init();
    },
};
